import type { PerspectiveValue, PerspectivePromptParts } from '../types'

function getHorizontalDirection(azimuth: number): string {
  const angle = ((azimuth % 360) + 360) % 360
  if (angle < 22.5 || angle >= 337.5) return 'front view'
  if (angle < 67.5) return 'front-right quarter view'
  if (angle < 112.5) return 'right side view'
  if (angle < 157.5) return 'back-right quarter view'
  if (angle < 202.5) return 'back view'
  if (angle < 247.5) return 'back-left quarter view'
  if (angle < 292.5) return 'left side view'
  return 'front-left quarter view'
}

function getVerticalDirection(elevation: number): string {
  if (elevation < -15) return 'low-angle shot'
  if (elevation < 15) return 'eye-level shot'
  if (elevation < 45) return 'elevated shot'
  return 'high-angle shot'
}

function getDistanceDescription(distance: number): string {
  if (distance < 2) return 'wide shot'
  if (distance < 6) return 'medium shot'
  return 'close-up'
}

export function getPerspectivePromptParts(value: PerspectiveValue): PerspectivePromptParts {
  const horizontal = getHorizontalDirection(value.azimuth)
  const vertical = getVerticalDirection(value.elevation)
  const distance = getDistanceDescription(value.distance)
  return {
    horizontal,
    vertical,
    distance,
    prompt: `<sks> ${horizontal} ${vertical} ${distance}`,
  }
}

export function generatePerspectivePrompt(value: PerspectiveValue): string {
  return getPerspectivePromptParts(value).prompt
}
